import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { JoinOrgButton } from '@/components/org/JoinOrgButton';
import { BackButton } from '@/components/ui/BackButton';

const PublicOrgList = () => {
  const { data: organizations = [], isLoading: loading, isError } = useQuery({
    queryKey: ['publicOrganizations'],
    queryFn: async () => {
      const response = await fetch('/api/org/public');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    },
  });

  const error = isError ? 'Failed to load organizations' : null;

  return (
    <div className="container mx-auto max-w-3xl py-8">
      <div className="flex justify-between items-center mb-6">
        <BackButton />
        <h1 className="text-2xl font-bold">Public Organizations</h1>
        <div className=""></div>
      </div>
      {loading && (
        <div className="flex justify-center items-center py-8">
          <span className="text-muted-foreground">Loading...</span>
        </div>
      )}
      {error && (
        <div className="flex justify-center items-center py-8">
          <span className="text-red-600">{error}</span>
        </div>
      )}
      <div className="grid gap-6 sm:grid-cols-2">
        {organizations.length === 0 ? (
          <div className="col-span-2 text-center text-muted-foreground">
            No public organizations available.
          </div>
        ) : (
          organizations.map((org) => (
            <Card key={org.id} className="hover:shadow-lg transition-shadow cursor-pointer">
              <CardHeader>
                <CardTitle>{org.name}</CardTitle>
                <JoinOrgButton orgId={org.id} />
              </CardHeader>
              <CardContent>
                {/* Add more org info here if available, e.g. description, member count, etc. */}
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </div>
  );
};

export { PublicOrgList };
